import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment, Typography } from '@mui/material';

EditableCalcNumber.propTypes = {
  field: PropTypes.object,
  row: PropTypes.array,
  currency: PropTypes.object,
  hasEditAccess: PropTypes.bool,
  updateUnsavedData: PropTypes.object,
  fCurrency: PropTypes.func,
};

function safeEval(expr) {
  if (!/^[\d+\-*/. ()]+$/.test(expr)) return NaN;
  try {
    // eslint-disable-next-line no-new-func
    return Function(`"use strict";return (${expr})`)();
  } catch {
    return NaN;
  }
}

export default function EditableCalcNumber({
  field,
  row,
  currency = false,
  hasEditAccess,
  updateUnsavedData,
  fCurrency,
}) {
  const [inputValue, setInputValue] = useState(row[field]?.toString() ?? '');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setInputValue(row[field]?.toString() ?? '');
    }
  }, [row[field], isEditing]);

  const handleChange = (e) => {
    setIsEditing(true);
    setInputValue(e.target.value);
  };

  const handleBlurOrEnter = (e) => {
    if (e.type === 'blur' || e.key === 'Enter') {
      const val = safeEval(inputValue);
      if (!Number.isNaN(val)) {
        const updatedRow = { ...row, [field]: Number(val) };
        updateUnsavedData(row, updatedRow);
        setInputValue(val.toString());
      }
      setIsEditing(false);
      e.preventDefault?.();
    }
  };

  if (!hasEditAccess) {
    return currency ? fCurrency(row[field]) : row[field];
  }

  return (
    <TextField
      type="text"
      autoComplete="off"
      disabled={!hasEditAccess}
      size="small"
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlurOrEnter}
      onKeyDown={handleBlurOrEnter}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#404042' }}>$</Typography>
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiInputBase-input': {
          fontSize: '0.8rem',
          fontWeight: 600,
        },
      }}
    />
  );
}
